import { ActionType } from 'typesafe-actions'

import { foodPriceHistoryActions, foodPriceHistoryActionType } from './actions'
import {
  FoodPriceHistory,
  FoodPriceHistoryPagination,
} from './food-price-histories'

export interface FoodPriceHistoryState {
  readonly histories: FoodPriceHistory[]
  readonly pagination: FoodPriceHistoryPagination
  readonly isLoading: boolean
  readonly error: Error | null
}

const initialState: FoodPriceHistoryState = {
  histories: [],
  pagination: {
    page: 1,
    per: 20,
    total: 0,
  },
  isLoading: false,
  error: null,
}

export const foodPriceHistoryReducer = (
  state: FoodPriceHistoryState = initialState,
  action: ActionType<typeof foodPriceHistoryActions>
): FoodPriceHistoryState => {
  switch (action.type) {
    case foodPriceHistoryActionType.FETCH_FOOD_PRICE_HISTORIES:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case foodPriceHistoryActionType.FETCH_FOOD_PRICE_HISTORIES_SUCCEEDED:
      return {
        ...state,
        histories: action.payload.histories,
        pagination: action.payload.pagination,
        isLoading: false,
        error: null,
      }
    case foodPriceHistoryActionType.THROW_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}
